import React from 'react';
import PropTypes from 'prop-types';

import DealsTable from 'bundles/apex/deals/table';
import EmptyState from './empty_state';
import { orderedColumns as allOrderedColumns } from './config';

export default function Deals({ deals, features }) {
  if (!deals.length) {
    return <EmptyState/>;
  }

  const orderedColumns = allOrderedColumns.filter(({ key }) => {
    switch (key) {
    case 'voucherAssociation':
      return features.projectDealsTableVoucherColumn;
    default:
      return true;
    }
  });

  return (
    <DealsTable deals={deals} hideTotals orderedColumns={orderedColumns} />
  );
}

Deals.propTypes = {
  deals: PropTypes.arrayOf(PropTypes.shape({
    dealTypeLabel: PropTypes.string.isRequired,
  })).isRequired,
  features: PropTypes.shape({
    projectDealsTableVoucherColumn: PropTypes.bool,
  }).isRequired,
};
